
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opprettforesporsel",
      function () {
        return require("private-next-pages/opprettforesporsel.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opprettforesporsel"])
      });
    }
  